import { useState } from 'react';
import { useForm } from 'react-hook-form';
import SuccessErrorMsg from "../../../../utilities/SuccessErrorMsg"
import { toast, ToastContainer } from "react-toastify";
import { afterTodayDate, todayDate } from "../../../../utilities/validations/dateValidations";
import { AddadminOffersform } from '../../../../hooks/apiAxios';
import moment from 'moment';
import { RiyalImgBLK } from '../../../../components/common/RiyalImg';


export function AddOffersData() {
    const { register, handleSubmit, formState: { errors }, setValue } = useForm();
    const [loading, setLoading] = useState(false);

    async function onSubmit(data) {
        setLoading(true);
        console.log(data);


        const formData = new FormData();

        formData.append("nameAr", data.nameAr);
        formData.append("nameEn", data.nameEn);
        formData.append("startDate", moment(data.startDate).toISOString());
        formData.append("endDate", moment(data.endDate).toISOString());
        formData.append("originalPrice", data.originalPrice);
        formData.append("discountedPrice", data.discountedPrice);
        formData.append("isAvailable", data.isAvailable);
        formData.append("descriptionAr", data.descriptionAr);
        formData.append("descriptionEn", data.descriptionEn);
        formData.append("image", data.image);

        try {
            const response = await AddadminOffersform(formData);

            if (response.data.isSuccess) {
                setTimeout(() => {
                    window.location.reload();
                }, 3000);
                toast.success("تم إضافة العرض بنجاح");
            } else {
                toast.error("حدث خطأ ما، حاول مرة أخرى");
            }
        } catch (error) {
            console.error("Error during form submission: ", error);
            toast.error("حدث خطأ ما، تواصل مع الدعم");
        } finally {
            setLoading(false);
        }
    }

    return (
        <div id="add-AdminOffers"
            className="modal fade bg-transparent"
            tabIndex="-1"
            aria-hidden="true"
            aria-labelledby="OffersAddForm"
            data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="OffersAddForm">إضافة عرض</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body p-0">
                        <form encType="multipart/form-data" method="post"
                            className='d-flex flex-column flex-md-row shadow mx-auto gap-2 text-start bg-white px-2 pb-4 rounded align-items-center'
                            onSubmit={handleSubmit(onSubmit)}>


                            <div className="d-flex flex-column col-12 col-md-11 mx-4 mb-5 mt-md-3 gap-2">

                                {/* Input fields */}


                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">العرض</span>
                                    <input
                                        className={`form-control ${errors.nameAr && "border border-danger"}`}
                                        type="text"
                                        placeholder='اسم العرض'
                                        // onChange={(e) => { setValue("title", e.target.value) }}
                                        {...register("nameAr", { required: true, minLength: 10 })}
                                    />
                                    {errors.nameAr && <p className='errors-msg'>الاسم مطلوب أكبر من ١٠ أحرف</p>}
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">Offer</span>
                                    <input
                                        className={`form-control ${errors.nameEn && "border border-danger"}`}
                                        type="text"
                                        placeholder='Offer Name'
                                        // onChange={(e) => { setValue("title", e.target.value) }}
                                        {...register("nameEn", { required: true, minLength: 10 })}
                                    />
                                    {errors.name && <p className='errors-msg'>الاسم مطلوب أكبر من ١٠ أحرف</p>}
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" >السعر قبل</span>
                                    <input className='form-control text-start'
                                        type="number" step="any"
                                        placeholder="ضع السعر شامل الضريبة"
                                        name='originalPrice'
                                        required
                                        {...register("originalPrice", { required: true })}
                                    />
                                    <span className="input-group-text" ><RiyalImgBLK /></span>

                                    {errors.originalPrice && <p className='errors-msg'>أدخل رقم فقط</p>}
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" >السعر بعد</span>
                                    <input className='form-control text-start'
                                        type="number" step="any"
                                        placeholder="ضع السعر شامل الضريبة"
                                        name='discountedPrice'
                                        required
                                        {...register("discountedPrice", { required: true })}
                                    />
                                    <span className="input-group-text" ><RiyalImgBLK /></span>

                                    {errors.discountedPrice && <p className='errors-msg'>أدخل رقم فقط</p>}
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" >تاريخ البداية</span>
                                    <input
                                        className='form-control text-start'
                                        type="date"
                                        min={todayDate}
                                        name='startDate'
                                        {...register("startDate", { required: true })}
                                    // onChange={(e) => { setValue("startDate", e.target.value) }}
                                    />
                                    {errors.startDate && <p className='errors-msg'>تاريخ البداية مطلوب</p>}
                                </div>
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" >تاريخ النهاية</span>
                                    <input
                                        className='form-control text-start'
                                        type="date"
                                        min={afterTodayDate}
                                        {...register("endDate", { required: true })}

                                    // onChange={(e) => { setValue("endDate", e.target.value) }}
                                    />
                                    {errors.endDate && <p className='errors-msg'>تاريخ النهاية مطلوب</p>}
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" >حالة العرض</span>
                                    <select className='form-select text-start'
                                        {...register("isAvailable")}
                                    >
                                        <option value={true}>تشغيل</option>
                                        <option value={false}>إيقاف</option>
                                    </select>
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">تفاصيل</span>
                                    <textarea
                                        className={`form-control ${errors.descriptionAr && "border border-danger"}`}
                                        type="textArea"
                                        rows="5"
                                        // onChange={(e) => { setValue("description", e.target.value) }}
                                        placeholder='تفاصيل الخدمة'
                                        // required
                                        {...register("descriptionAr", { minLength: 10 })} />
                                    {errors.descriptionAr && <p className='errors-msg'> مطلوب أكبر من ١٠ أحرف</p>}
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">Details</span>
                                    <textarea
                                        className={`form-control ${errors.description && "border border-danger"}`}
                                        type="textArea"
                                        rows="7"
                                        onChange={(e) => { setValue("descriptionEn", e.target.value) }}
                                        placeholder='Details'
                                        {...register("descriptionEn", { required: true, minLength: 10 })} />
                                    {errors.description && <p className='errors-msg'> مطلوب أكبر من ١٠ أحرف</p>}
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" >صورة</span>
                                    <input className='form-control'
                                        type="file"
                                        accept="image/JPG"
                                        onChange={e => setValue("image", e.target.files[0])}
                                    />
                                    {errors.image && <p className='errors-msg'>يجب أن يكون صورة</p>}
                                </div>
                                <button
                                    className='btn btn-dark-orange text-white col-2 me-3 mb-3 position-absolute bottom-0 end-0'
                                    type="submit">
                                    {loading &&
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"></span>
                                    }
                                    حفظ
                                </button>
                            </div>
                        </form>
                        <SuccessErrorMsg
                            ToastContainer={ToastContainer}
                        />
                    </div>
                </div>
            </div>
        </div>

    )
}